import useRedux from "./useRedux"

export default () => {
  return useRedux(state => state.core.sdk?.wallet)
}
